<template>
    <div class="jump-cart">
        <van-nav-bar title="订单积分统计" left-arrow fixed class="jump-nav-bar" @click-left="back"/>
        <div class="jump-cart-body">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-row class="jump-cart-item" type="flex" v-for="item in list">
                    <van-col span="24">
                            <van-cell title="客户名称" :value="item.userName" v-if="roleType=='BM'"/>
                            <van-cell title="分公司名称" :value="item.userName" v-if="roleType=='ECENGINEER'"/>
                            <van-cell title="牧场名称" :value="item.mcmc" v-if="roleType=='BM'"/>
                            <van-cell title="积分数" :value="item.integralValue" />
                            <van-cell title="消费金额" :value="item.consumeAmount" />
                            <van-cell title="统计开始时间" :value="item.statBeginTime" />
                            <van-cell title="统计结束时间" :value="item.statEndTime" />
                    </van-col>
                </van-row>
            </van-list>
        </div>
        <BackTop />
    </div>
</template>
<script>
    import {NavBar, Row, Col, List,Cell, CellGroup} from "vant";
    export default {
        name: "userhistory",
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [List.name]: List
        },
        data() {
            return {
          
                checkedAll: false,
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1,
                startTime:'',
                roleType:'',
                url:''
            };
        }, mounted: function () {
             this.startTime=this.$route.query.time;
             this.roleType=this.$route.query.role;
             //业务员，电商买家
             if(this.roleType=='BM'){
                 this.url=this.jumuc.integralStatisticBiz
             }else if(this.roleType=='ECENGINEER'){
                  this.url=this.jumuc.integralStatEngineer
             }
        },
        methods: {
            back() {
                history.back();
            },
             onLoad() {
               let that = this;
                // 异步更新数据
                that.$api.post(
                    this.url,
                    {"currentPage": that.page, "pageSize": 10,"time":this.startTime},
                    successRes => {
                      if(this.roleType=='BM'){
                            let orderlist = successRes.data.integralStatistiBizList.list//业务员;
                            that.page = successRes.data.integralStatistiBizList.pageNum + 1
                           that.total = successRes.data.integralStatistiBizList.total;
                           for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (this.list.length >= that.total) {
                            that.finished = true;
                        }
                        }else if(this.roleType=='ECENGINEER'){
                             let orderlist = successRes.data.integralStatEngineerList.list//电商
                             that.page = successRes.data.integralStatEngineerList.pageNum + 1
                             that.total = successRes.data.integralStatEngineerList.total;
                             for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (this.list.length >= that.total) {
                            that.finished = true;
                        }
                        }
                       
                        
                    }
                )

            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-cart {


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 90%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
                &.item-time {
                    color: @bule-thame;
                    font-size: 16px;
                    text-align: right;
                }
                &.item-price {
                    color: red;
                    font-size: 16px;
                    i {
                        font-size: 18px;
                        float: right;
                        color: #f5a623
                    }
                }
            }
        }
    }
</style>

